import { FormInput } from '../../..';
import { FormInputModel } from '../../../../models';
import { HandleValueModel } from '../../../../models/component/HandleValueModel';
import { PressureModeNormal } from '../icons';
import { Row } from 'reactstrap';
import SettingsFormProps from '../SettingsFormProps';
import { observer } from 'mobx-react';

const PressureNormalField = ({ translate, settingsModel, accessTable, disabled }: SettingsFormProps) => {
  const label = translate(x => x.forms.airdome.settings.pressureNormal);

  return <Row>
    <div className="settings-field-icon">
      <PressureModeNormal style={{ width: '100%', height: 40 }} />
    </div>
    <div className="settings-field-input">
      <FormInput {...{
        model: new FormInputModel({
          label,
          validationSchema: settingsModel.pressureNormalValidationSchema.label(label),
          placeholder: label,
          handleValueModel: new HandleValueModel({
            setValue: settingsModel.pressureNormal.setValue,
            inputType: 'number'
          }),
          inputId: 'PressureNormal',
          value: settingsModel.pressureNormal.Value ? (Math.round(settingsModel.pressureNormal.Value * 10) / 10).toString() : '',
          readonly: disabled || !accessTable.edit
        })
      }} />
    </div>
  </Row>;
};

export default observer(PressureNormalField);
